import { render, staticRenderFns } from "./Question2.vue?vue&type=template&id=26e6dde4&scoped=true&"
import script from "./Question2.vue?vue&type=script&lang=js&"
export * from "./Question2.vue?vue&type=script&lang=js&"
import style0 from "./Question2.vue?vue&type=style&index=0&id=26e6dde4&lang=scss&scoped=true&"
import style1 from "./Question2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e6dde4",
  null
  
)

component.options.__file = "Question2.vue"
export default component.exports